import { render } from "./sandTableCollapse.vue?vue&type=template&id=48c0274a&scoped=true"
import script from "./sandTableCollapse.vue?vue&type=script&lang=js"
export * from "./sandTableCollapse.vue?vue&type=script&lang=js"

import "./sandTableCollapse.vue?vue&type=style&index=0&id=48c0274a&lang=scss"
import "./sandTableCollapse.vue?vue&type=style&index=1&id=48c0274a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c0274a"]])

export default __exports__